import { render } from "./ProfileDropdown.vue?vue&type=template&id=4d2979f6&scoped=true&ts=true"
import script from "./ProfileDropdown.vue?vue&type=script&lang=ts"
export * from "./ProfileDropdown.vue?vue&type=script&lang=ts"

import "./ProfileDropdown.vue?vue&type=style&index=0&id=4d2979f6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d2979f6"]])

export default __exports__